module.exports = __webpack_public_path__ + "img/souhuxinwen.9c0c135b.png";